// Header Images
export const NUSTARTZ_LOGO = "/assets/Header/Nustartz new logo 2x 1.png";

// Home Page Images
export const CLOUDS_3D_ILLUSTRATION =
  "/assets/Home Page/PNG/pngtree-3d-white-clouds-illustration-png-image_6478630 1.png";
export const PAPER_PLANE_3D =
  "/assets/Home Page/PNG/paper-plane-3d-design-free-png 1.png";
export const VISION_ILLUSTRATION = "/assets/Home Page/PNG/Vector 1.png";
export const STAR = "/assets/Home Page/PNG/star.png";

// Insights Page Images
export const INSIGHTS_ROCKET = "/assets/Insights/rocket 1.png";
export const INSIGHTS_BLOG_IMAGE1 =
  "/assets/Insights/how-to-build-a-startup-team-1920x1200 1.png";
export const INSIGHTS_BLOG_IMAGE2 = "/assets/Insights/Frame 73.png";
export const INSIGHTS_BLOG_IMAGE3 = "/assets/Insights/Frame 74.png";
export const INSIGHTS_NEWS_IMAGE1 =
  "/assets/Insights/NuStartz Summer 2025  Newletter Banner 1.png";
export const INSIGHTS_NEWS_IMAGE2 =
  "/assets/Insights/Nustartz News Banner 2.png";
export const INSIGHTS_NEWS_IMAGE3 = "/assets/Insights/NuStartz India firrst Expo Banner 3.jpg";
export const NEWS1_IMAGE1 = "/assets/News_1/0001.png";
export const NEWS1_IMAGE2 = "/assets/News_1/0002.png";
export const NEWS1_IMAGE3 = "/assets/News_1/0003.png";
export const NEWS1_IMAGE4 = "/assets/News_1/Rectangle.png";
export const NEWS1_IMAGE5 = "/assets/News_1/0005.png";
export const NEWS1_IMAGE6 = "/assets/News_1/0006.png";
export const NEWS1_IMAGE7 = "/assets/News_1/0007.png";
export const NEWS1_IMAGE8 = "/assets/News_1/0008.png";

export const NEWS2_IMAGE1 = "/assets/News_4/1.png";
export const NEWS2_IMAGE2 = "/assets/News_4/2.png";
export const NEWS2_IMAGE3 = "/assets/News_4/3.png";
export const NEWS2_IMAGE4 = "/assets/News_4/4.png";
export const NEWS2_IMAGE5 = "/assets/News_4/5.png";
export const NEWS2_IMAGE6 = "/assets/News_4/6.png";
export const NEWS2_IMAGE7 = "/assets/News_4/7.png";

export const BLOG1_IMAGE1 = "/assets/Blog/how-to-build-a-startup-team-1920x1200 1.png";
export const BLOG2_IMAGE1 = "/assets/Blog/vc-pitch-deck-inc-GettyImages-2162946020_544852_ex5rah 1.png";
export const BLOG3_IMAGE1 = "/assets/Blog/tech-ideas 1.png";

export const INSIGHTS_EVENTS_IMAGE1 = "/assets/Events_1/R_1L2173 2.png";
export const INSIGHTS_EVENTS_IMAGE2 = "/assets/Events_2/R_1L2889 1.png";
export const INSIGHTS_EVENTS_IMAGE3 = "/assets/Events_3/8O2A6701 1.png";
// Events Page Images
export const EVENTS1_IMAGE1 = "/assets/Events_1/R_1L2091 2.png";
export const EVENTS1_IMAGE2 = "/assets/Events_1/R_1L2195 1.png";
export const EVENTS1_IMAGE3 = "/assets/Events_1/R_1L2331 1.png";

export const EVENTS2_IMAGE1 = "/assets/Events_2/R_1L2934 1.png";

export const EVENTS3_IMAGE1 = "/assets/Events_3/8O2A6771 1.png";
export const EVENTS3_IMAGE2 = "/assets/Events_3/8O2A6757 1.png";


// About Us Page Images
export const BEN_IMAGE = "/assets/About Us/ben bg 1.png";
export const SIVA_IMAGE = "/assets/About Us/Frame 277.png";
export const STEVE_IMAGE = "/assets/About Us/Steve black & white 1.png";
export const ARUN_IMAGE = "/assets/About Us/Arunb.png";
export const NAGARAJ_IMAGE = "/assets/About Us/nagaraj 1.png";
export const SUJITH_IMAGE = "/assets/About Us/Frame 281.png";
export const MICHAEL_IMAGE = "/assets/About Us/Michael.png";
export const RAGAVI_IMAGE = "/assets/About Us/Raghavi 1.png";
export const VIJAY_IMAGE = "/assets/About Us/frame 002.png";
export const IGOR_IMAGE = "/assets/About Us/igor 1.png";
export const SUMMER_IMAGE = "/assets/About Us/Summer 1.png";
export const CUP_HOLDING_IMAGE = "/assets/About Us/3d-render-of-hand.png";

// Services Page Images
export const HAND_WITH_BULB_IMAGE =
  "/assets/Services/e145af9d-b78a-450a-b972-5c7be9265707 1.png";
export const BULB_GLOW_EFFECT = "/assets/Services/Ellipse 24.png";
export const BLOB_IMAGE = "/assets/Services/Mask group.png";

// Logos (SVG)
export const LOGO_TELE_DOCTOR_GREY =
  "/assets/Logos/SVG/tele_doctor_logo_ grey 1.svg";
export const LOGO_GREEN_LIGHT_GREY =
  "/assets/Logos/SVG/Green light grey  1.svg";
export const LOGO_YOTTAASYS_GREY = "/assets/Logos/SVG/yottaasys_ grey  1.svg";
export const LOGO_MAMENTA_GREY = "/assets/Logos/SVG/mamenta grey 1.svg";

// Clients Logos (PNG)
export const LOGO_BEYOND_MEDIA =
  "/assets/Logos/Clients/Beyond media.png";
  export const LOGO_BLV =
  "/assets/Logos/Clients/BLv .png";
  export const LOGO_CARRER_JOURNEY =
  "/assets/Logos/Clients/Carrer Journey.png";
  export const LOGO_MOXXI =
  "/assets/Logos/Clients/Moxxi.png";
  export const LOGO_MYNA =
  "/assets/Logos/Clients/Myna-Logo-.png";
  export const LOGO_SG_LABS =
  "/assets/Logos/Clients/Sg labs.png";
  export const LOGO_SUPPLY_NOW =
  "/assets/Logos/Clients/Supply now.png";
  export const LOGO_XANDER =
  "/assets/Logos/Clients/Xander.png";


export const LOGO_TECHDAY_NYC_GREY =
  "/assets/Logos/SVG/Techday NYC greyn 1.svg";
export const LOGO_SNAP_LOGIC_GREY = "/assets/Logos/SVG/snap logic grey 1.svg";
export const LOGO_MICROSOFT_GREY = "/assets/Logos/SVG/Microsoft grey 1.svg";
export const LOGO_KORE_AI_GREY = "/assets/Logos/SVG/kore ai grey  1.svg";
export const LOGO_NUSTRATZ = "/assets/Logos/PNG/favicon nustartz 2.png";

// Partner Logos (PNG)
export const LOGO_CRAFTER_CMS =
  "/assets/Logos/Partners/Crafter CMS.png";
export const LOGO_DATA_BRICKS =
  "/assets/Logos/Partners/Data bricks.png";
  export const LOGO_JUMPSTARTZ =
  "/assets/Logos/Partners/Jumpstartz.png";
  export const LOGO_NY_TECH =
  "/assets/Logos/Partners/Ny tech .png";

